// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  filterConfig: {
    apiUrl: 'https://qa-iqcentral-eagsdtajbrfyd2fj.eastus-01.azurewebsites.net',
  },
  API_URL_V1:
    'https://qa-iqcentral-eagsdtajbrfyd2fj.eastus-01.azurewebsites.net',
  FRONTEND_ENTERPRISE_URL: 'https://dev-org.iqcentral.quomodosystems.ng',
  FRONTEND_LEARNERS_URL: 'https://dev-learner.iqcentral.quomodosystems.ng',
  FRONTEND_CONTENT_PROVIDERS_URL: 'https://dev-cp.iqcentral.quomodosystems.ng',
  FRONTEND_HOMEPAGE_URL: 'https://dev-iqcentral.quomodosystems.ng',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
